import React from 'react'
import { fnum } from '../../utils/utils'
import PRSEditSubTotal from './PRSEditSubTotal'
import PRSAddSubTotal from './PRSAddSubTotal'

export default class PRSSubTotalItem extends React.Component {

  state = {
    edit: false,
    add: false
  }

  startEdit = e => {
    e.preventDefault();
    this.setState({edit: true});
  }

  cancelEdit = () => {
    this.setState({edit: false});
  }

  startAdd = () => {
    this.setState({add: true});
  }

  cancelAdd = () => {
    this.setState({add: false});
  }

  render() {

    const { order, data, preSum, editPost, srvcs, srvgs, updtBlnc, type } = this.props;

    if(data.hasOwnProperty('post_desc')){
      if (this.state.edit){
        return (
          <PRSEditSubTotal
            preSum={preSum}
            editPost={editPost}
            data={data}
            cancelEdit={this.cancelEdit}
            updtBlnc={updtBlnc}
            srvcs={srvcs}
            srvgs={srvgs}
            type={type}
          />
        );
      }
      else {
        const style = data.post_price*data.post_qntt !== preSum
          ? 'text-right danger text-danger'
          : 'text-right';
        return (
          <tr onClick={this.startEdit}>
            <td></td>
            <td>{data.post_desc}</td>
            <td></td>
            <td></td>
            <td className={style}>{fnum(data.post_price*data.post_qntt)}</td>
            <td></td>
            <td className="text-right text-success">{fnum(data.post_price*data.post_qntt)}</td>
            <td>{data.post_note}</td>
          </tr>
        )
      }
    }
    else{
      if (this.state.add){
        return (
          <PRSAddSubTotal
            data={{
              post_desc: "",
              post_srvc_id: 0,
              post_price: preSum,
              post_qntt: 1,
              post_note: "",
              post_order_id: order.order_id,
              post_active: 1,
              post_avans: 1,
              post_payed: 0,
              post_seller:order.order_comp1_id,
              post_payer:order.order_comp_id,
              post_bdate:order.order_edate
            }}
            srvcs={srvcs}
            srvgs={srvgs}
            editPost={editPost}
            cancelAdd={this.cancelAdd}
            updtBlnc={updtBlnc}
            type={type}
          />
        );
      }
      else {
        if(preSum !== 0) {
          return (
            <tr onClick={this.startAdd} >
              <td></td>
              <td className="danger text-danger">
                <u>Нажмите, чтобы добавить {type === 1 ? 'надбавку' : 'налог'}</u>
              </td>
              <td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
          );
        }
        else {
          return null;
        }
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSSubTotalItem.js